import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";

import styles from "./styles";
const useStyles = makeStyles(styles);

function Loading(props) {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <div className={classes.overlay}></div>
      <div className={classes.content}>
        <CircularProgress />
      </div>
    </div>
  );
}

export default Loading;
